module.exports = __webpack_public_path__ + "img/smartphone.4b61b207.svg";